import React from 'react';
import { FiHome, FiTrendingUp, FiUsers, FiVideo, FiActivity, FiMousePointer, FiZap } from 'react-icons/fi';

export const getOwnerMenuItems = () => [
  { icon: <FiHome />, label: 'Dashboard', path: '/owner' },
  { icon: <FiTrendingUp />, label: 'Revenue', path: '/owner/revenue' },
  { icon: <FiUsers />, label: 'Users', path: '/owner/users' },
  { icon: <FiVideo />, label: 'Content', path: '/owner/content' },
  { icon: <FiActivity />, label: 'Engagement', path: '/owner/engagement' },
  { icon: <FiMousePointer />, label: 'Conversion Funnel', path: '/owner/funnel' },
  { icon: <FiZap />, label: 'Insights', path: '/owner/insights' },
];

